<template>
  <div>
    <div v-if="selectedReport === 'all-order' || selectedReport === 'merchant-invoice'">
      <report-downloads-table
        :key="selectedReport"
      />
    </div>
    <div v-else-if="selectedReport === 'assigned-order-reports'">
      <assigned-order-queued-downloads />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions,camelcase
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ReportDownloadsTable from '@/views/reports/Downloads/ReportDownloadsTable.vue'
import AssignedOrderQueuedDownloads from '@/views/reports/Downloads/AssignedOrderQueuedDownloads.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    ReportDownloadsTable,
    AssignedOrderQueuedDownloads,
  },
  data() {
    return {
      selectedReport: '',
    }
  },
  mounted() {
    this.getKey()
    this.updateBreadcrumb()
  },
  methods: {
    getKey() {
      this.selectedReport = this.$route.params.key
    },
    updateBreadcrumb() {
      if (this.$route.meta.breadcrumb) {
        const lastBreadcrumb = this.$route.meta.breadcrumb[this.$route.meta.breadcrumb.length - 1]
        if (this.selectedReport === 'merchant-invoice') {
          lastBreadcrumb.text = 'Merchant Invoice'
        } else if (this.selectedReport === 'assigned-order-reports') {
          lastBreadcrumb.text = 'Assigned Orders'
        } else if (this.selectedReport === 'all-order') {
          lastBreadcrumb.text = 'All Orders'
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import 'src/@core/scss/vue/libs/vue-select';
</style>
